import { Unit } from "@/types";

export const getUnitList = (
  countries: Array<Unit>,
  federalStates: Array<Unit>,
  districts: Array<Unit>,
) => {
  let result: Array<Unit & { children: Array<Unit & { children: Array<Unit> }> }> = countries.map(
    (country) => ({
      ...country,
      children: [],
    }),
  );
  result = result.map((country) => {
    for (let i = 0; i < federalStates?.length; i++) {
      if (federalStates[i].code.split(".")[0] === country.code) {
        country.children.push({ ...federalStates[i], children: [] });
      }
    }
    return country;
  });

  result = result.map((country) => {
    for (let i = 0; i < country.children?.length; i++) {
      for (let j = 0; j < districts?.length; j++) {
        const splittedFSCode = country.children[i].code.split(".");
        const districtSplitterCode = districts[j].code.split(".");
        if (
          splittedFSCode[0] === districtSplitterCode[0] &&
          splittedFSCode[1] === districtSplitterCode[1]
        ) {
          country.children[i].children.push(districts[j]);
        }
      }
    }
    return country;
  });

  return result;
};
